export default __webpack_public_path__ + "static/media/logo.e7a6570a.png";